// extracted by mini-css-extract-plugin
export default {"noDataFoundTitle":"NoResultFound_noDataFoundTitle__RlHBN","noDataFoundDescription":"NoResultFound_noDataFoundDescription__QafFz"};